import React from 'react';
import { motion } from 'framer-motion';

const { brands } = require('data/services.json');

export default function BrandsCarrusel() {
  return (
    <motion.div
      className="container-full"
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <div className="white-container services-brands">
        
        <motion.h2
          className="k-title-sm lg:k-title-md"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
        >
          Brands that trust us
        </motion.h2>

        <BrandsMarquee />

        <motion.a
          className="btn-black"
          href="/work"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.5, ease: 'easeOut', delay: 0.1 }}
        >
          Check out our latest work
        </motion.a>
      </div>
    </motion.div>
  );
}

function BrandsMarquee() {
  const items = brands || [];

  return (
    <motion.div
      className="services-brands-carrusel"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <div className="fade-left" />
      <div className="fade-right" />

      <div className="services-brands-carrusel-list">
        {items.map((item, i) => (
          <div key={`${item.image}-${i}`} className="services-brands-carrusel-item">
            <img
              src={`/images/brands/${item.image}`}
              alt={item.alt}
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </motion.div>
  );
}